var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action } from 'mobx';
import AbstractChartStore from './AbstractChartStore';
export default class ChartStore extends AbstractChartStore {
    constructor(id, xLegend, yLegend, defaultData = { id: 'default', data: [] }) {
        super();
        this.id = id;
        this.xLegend = xLegend;
        this.yLegend = yLegend;
        this.lines = [defaultData];
    }
    addPoint(x, y, id = 'default') {
        let dataSerie = this.lines.find((lD) => lD.id === id);
        if (!dataSerie) {
            dataSerie = { id, data: [] };
            this.lines.push(dataSerie);
        }
        // overwrite data based on x-axis value
        const data = dataSerie.data.find((d) => d.x === x);
        if (data) {
            data.y = y;
        }
        else {
            dataSerie.data.push({ x, y });
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], ChartStore.prototype, "xLegend", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], ChartStore.prototype, "yLegend", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], ChartStore.prototype, "lines", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Number, String]),
    __metadata("design:returntype", void 0)
], ChartStore.prototype, "addPoint", null);
